import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatPaginator, MatDialog, PageEvent, Sort, MatTabChangeEvent } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { ExcelHelperService } from 'src/app/Services/Utilities/excel-helper.service';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
    vanguardList = [];
    trailblazerList = [];
  
    filelist = [];
    sortedfilelist = [];
    length = 0;
    pageSize = 50;
    pageSizeOptions: number[] = [10, 15, 20];
    pageIndex = 0;
    offset = this.pageSize * this.pageIndex;
    searchbox = '';
    searchValue = '';
    sortedu = {
      active: '',
      direction: ''
    };
    loading = true;
    selectedIndex = 0;
    parentSelectedIndex = 0;
    parent2SelectedIndex = 0;
  
  
    role: string[];
  
    types = [
      'Health & Well-being',
      'Energy & Environment protection',
      'Education & Enhancing Communities',
      'Responsible Industry & Partnership'
    ]
    filter = 'Health & Well-being'
  
    @ViewChild('topPaginator', { read: MatPaginator, static: false }) topPaginator: MatPaginator;
  
    constructor(
      private userinfoSrv: UserInfoService,
      private firestore: AngularFirestore,
      private spinner: NgxSpinnerService,
      private dialog: MatDialog,
      private angularFireAuth: AngularFireAuth,
      private toaster: ToastrService,
      private router: Router,
      private excelHelper: ExcelHelperService
    ) { 
      this.userinfoSrv.currentRole.subscribe(role => this.role = role);
      this.getFile();
    }
  
    email=''
  
    ngOnInit() {
      this.angularFireAuth.authState.subscribe(async authState => {
        this.spinner.show()
        if (authState === null) {
          this.spinner.hide();
        } else {
          this.email = this.email;
          await this.firestore.collection("Admin").doc(authState.uid).get().forEach(async e => {
            if (e.exists) {
              const role = []
              role.push(e.data().Role);
            }
            else {
              this.router.navigate([''])
            }
          });
          this.spinner.hide();
        }
      })
    }
  
    getFile(){
      this.firestore.collection('Exhib').get().forEach(e => {
        e.forEach(file => {
          const data : any= {
            ...file.data(),
            id: file.id,
            fileName: file.data().FileNames ? file.data().FileNames.join('\n') : "Not yet upload",
            calculatedMark: file.data().calculatedMark,
            totalMark: 0,
            averageMark: 0,
            marks: file.data().marks,
            CreatedDate: new Date(file.data().CreatedDate.toDate())
          }
  
          if(!data.finalMark){
              
            if (data.calculatedMark) {
              for (const mark of Object.values(data.calculatedMark)) {
                data.totalMark += parseFloat(this.getMark(mark));
              }
              data.averageMark = data.totalMark / Object.values(data.calculatedMark).length;
            }
          }else{
            data.averageMark = parseFloat(data.finalMark);
          }
  
          if(data.modeInfo?data.modeInfo.category.includes('Trailblazer'): false){
            this.trailblazerList.push(data)
          }else if(data.modeInfo?data.modeInfo.category.includes('Vanguard'): false){
            this.vanguardList.push(data)
          }
  
          this.sortedfilelist = this.filterAgain();
          this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
          this.loading = false;
          this.length = this.filterAgain().length;
        })
        this.spinner.hide();
        this.loading = false;
      });
    }
  
    numberOfApplication = 0;
    totalMark = 0;
    avgMark = 0;
    goldThreshold = 0;
    silverThreshold = 0;
    bronzeThreshold = 0;
    vanguard1 = [];
    vanguard2 = [];
    vanguard3 = [];
    category1 = [];
    category2 = [];
    category3 = [];
    category4 = [];
  
    marked1Application = []
    marked2Application = []
    filterAgain(){
      this.numberOfApplication = 0;
      this.totalMark = 0;
      this.avgMark = 0;
      this.goldThreshold = 0;
      this.silverThreshold = 0;
      this.bronzeThreshold = 0;
      this.vanguard1 = [];
      this.vanguard2 = [];
      this.vanguard3 = [];
      this.category1 = [];
      this.category2 = [];
      this.category3 = [];
      this.category4 = [];
  
      if(this.parentSelectedIndex === 0){
        this.filelist = this.vanguardList.filter(e=>e.averageMark > 0 && e.modeInfo.mode === 'Physical').slice();
        this.marked1Application = this.vanguardList.filter(e=>e.averageMark > 0 && e.modeInfo.mode === 'Physical').slice();
      }else{
        this.filelist = this.trailblazerList.filter(e=>e.averageMark > 0 && e.modeInfo.mode === 'Physical').slice();
        this.marked2Application = this.trailblazerList.filter(e=>e.averageMark > 0 && e.modeInfo.mode === 'Physical').slice();
      }
      this.filelist = this.filelist.sort((a,b)=> this.compare(a.averageMark, b.averageMark, false))
  
      this.filelist = this.filelist.map((value, index)=> { 
        let place = index + 1;
        if(this.filelist[index-1]){
          if(value.averageMark === this.filelist[index-1].averageMark){
            place = place -1
          }
        }
        return {...value, place: place}
      })
  
      let list1 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[0]).map((value, index)=> { 
        let place = index + 1;
        if(this.filelist[index-1]){
          if(value.averageMark === this.filelist[index-1].averageMark){
            place = place -1
          }
        }
        return {...value, place: place}
      })
      let list2 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[1]).map((value, index)=> { 
        let place = index + 1;
        if(this.filelist[index-1]){
          if(value.averageMark === this.filelist[index-1].averageMark){
            place = place -1
          }
        }
        return {...value, place: place}
      })
      let list3 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[2]).map((value, index)=> { 
        let place = index + 1;
        if(this.filelist[index-1]){
          if(value.averageMark === this.filelist[index-1].averageMark){
            place = place -1
          }
        }
        return {...value, place: place}
      })
      let list4 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[3]).map((value, index)=> { 
        let place = index + 1;
        if(this.filelist[index-1]){
          if(value.averageMark === this.filelist[index-1].averageMark){
            place = place -1
          }
        }
        return {...value, place: place}
      })

      // this.filelist = list1.concat(list2).concat(list3).concat(list4)
  
     
      // this.filelist = this.filelist.sort((a,b)=> this.compare(a.place, b.place, true))

  
      this.filelist = [];
      if(list1.length > 0)
        this.filelist =  this.filelist.concat(list1.filter(a=>a.place === 1))
      if(list2.length > 0)
        this.filelist = this.filelist.concat(list2.filter(a=>a.place === 1))
      if(list3.length > 0)
        this.filelist =  this.filelist.concat(list3.filter(a=>a.place === 1))
      if(list4.length > 0)
        this.filelist =  this.filelist.concat(list4.filter(a=>a.place === 1))
      
  
      let dup = this.filelist.slice();
     
      let totalMark = dup.reduce((a,b)=> a + b.averageMark, 0);
      this.numberOfApplication =  dup.length;
      this.totalMark = totalMark;
  
      if(totalMark > 0){
        this.avgMark = (totalMark/dup.length);
        let goldThreshold = Math.floor((dup.length * 0.3))
        let silverThreshold = Math.floor((dup.length * 0.4))
        let bronzeThreshold = dup.length - goldThreshold - silverThreshold;
  
        this.goldThreshold = goldThreshold;
        this.silverThreshold = silverThreshold;
        this.bronzeThreshold = bronzeThreshold;
        for (let index = 0; index < dup.length; index++) {
          const element = dup[index];
  
          if(index+1 <= goldThreshold){
            element.result = 'Gold'
          }else if(index+1 <= goldThreshold + silverThreshold){
            element.result = 'Silver'
          }else{
            element.result = 'Bronze'
          }
        }
       
      }
      return dup;
    }
  
    getMark(marks) {
      return marks.reduce((a, b) => a + (b?parseFloat(b): 0), 0).toFixed(2)
    }
  
    getSMark(email, file) {
      let str = ''
      str = file.calculatedMark ? Object.keys(file.calculatedMark).includes(email) ? this.getMark(file.calculatedMark[email]) : '?' : '?';
      return str;
    }
  
    paginator(pageEvent: PageEvent) {
      this.pageSize = pageEvent.pageSize;
      this.pageIndex = pageEvent.pageIndex;
      this.offset = this.pageSize * this.pageIndex;
      
      this.sortedfilelist = this.filterAgain();
      this.sortFile();
      this.limitFile();
    }
  
    limitFile() {
      this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
    }
  
    sortData(sort: Sort) {
      this.sortedu = sort;
      this.sortedfilelist = this.filterAgain();
     
      if (!sort.active || sort.direction === '' ) {
        this.sortedfilelist = this.filterAgain();
        this.limitFile();
        return;
      }
  
      this.sortedfilelist = this.sortedfilelist.sort((a, b) => {
        const isAsc = this.sortedu.direction === 'asc';
        switch (this.sortedu.active) {
          case 'title': return this.compare(a.introFormGroup.ProjectTitle, b.introFormGroup.ProjectTitle, isAsc);
          case 'name': return this.compare(a.introFormGroup.Applicant, b.introFormGroup.Applicant, isAsc);
          case 'id': return this.compare(a.id, b.id, isAsc);
          case 'ins': return this.compare(a.introFormGroup.School, b.introFormGroup.School, isAsc);
          case 'avgMark': return this.compare(a.averageMark, b.averageMark, isAsc);
          case 'category': return this.compare(a.techFormGroup.Category, b.techFormGroup.Category, isAsc);
          case 'result': return this.compare(a.result, b.result, isAsc);
          case 'award': return this.compare(a.award, b.award, isAsc);
          case 'place': return this.compare(a.place, b.place, isAsc);
          default: return 0;
        }
      });
      this.limitFile();
    }
  
    sortFile() {
      if (!this.sortedu.active || this.sortedu.direction === '') {
        return;
      }
      this.sortedfilelist = this.sortedfilelist.sort((a, b) => {
        const isAsc = this.sortedu.direction === 'asc';
        switch (this.sortedu.active) {
          case 'title': return this.compare(a.introFormGroup.ProjectTitle, b.introFormGroup.ProjectTitle, isAsc);
          case 'name': return this.compare(a.introFormGroup.Applicant, b.introFormGroup.Applicant, isAsc);
          case 'id': return this.compare(a.id, b.id, isAsc);
          case 'ins': return this.compare(a.introFormGroup.School, b.introFormGroup.School, isAsc);
          case 'avgMark': return this.compare(a.averageMark, b.averageMark, isAsc);
          case 'category': return this.compare(a.techFormGroup.Category, b.techFormGroup.Category, isAsc);
          case 'result': return this.compare(a.result, b.result, isAsc);
          case 'award': return this.compare(a.award, b.award, isAsc);
          case 'place': return this.compare(a.place, b.place, isAsc);
          default: return 0;
        }
      });
    }
  
    compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
  
    compareDate(a, b, isAsc: boolean) {
      a = new Date(a);
      b = new Date(b);
      return (a > b ? -1 : a < b ? 1 : 0) * (isAsc ? -1 : 1);
    }
  
    tabChanged(event: MatTabChangeEvent){
      this.selectedIndex = event.index;
      console.log(this.selectedIndex)
      this.filter = this.types[event.index]
      this.sortedfilelist = this.filterAgain();
      this.topPaginator.firstPage();
      this.pageIndex = 0;
      this.offset = this.pageSize * this.pageIndex;
      this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
      this.length = this.filterAgain().length;
  
    }
  
    parentTabChanged(event: MatTabChangeEvent){
      this.parentSelectedIndex = event.index;
      this.sortedfilelist = this.filterAgain();
      this.topPaginator.firstPage();
      this.pageIndex = 0;
      this.offset = this.pageSize * this.pageIndex;
      this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
      this.length = this.filterAgain().length;
    }
  
    dateFormat = new DateFormatService();
   
    exportExcel() {
      const exportInformation = [];
  
      this.spinner.show();
      let file = this.filterAgain();
  
      for (const p of file) {
        const info = {
          "ID": p.id,
          "Invention Title": p.introFormGroup.ProjectTitle || '-',
          "Participant's name": p.introFormGroup.Applicant || '-',
          "Institution": p.introFormGroup.School || '-',
          "Category": p.techFormGroup.Category,
          "Marks": p.averageMark.toFixed(2),
          "Result": p.result || '-',
        }
       
        exportInformation.push(info)
      }
      let naming = (this.parentSelectedIndex === 0? 'Vanguard': 'Traiblazer') + '_CategoryAward' 
    
      this.excelHelper.exportAsExcelFile(exportInformation, naming + new Date().getTime());
  
      this.spinner.hide();
  
    }
   
  }